
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexys1qErV1bGMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/ceo/index.vue?macro=true";
import { default as indexFJxrNCJKjKMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/customer-service/index.vue?macro=true";
import { default as indexHvwaloWIJjMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/dashboard/index.vue?macro=true";
import { default as indexuGjfd422WVMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/greeting/index.vue?macro=true";
import { default as index30iB83j3tHMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/[hrId]/index.vue?macro=true";
import { default as indexZ6OFxJ0LSCMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/index.vue?macro=true";
import { default as write0Zsamok7GoMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/write.vue?macro=true";
import { default as indexVGsj7JK8TRMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/index.vue?macro=true";
import { default as indexrtUWuunv1RMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/insa/index.vue?macro=true";
import { default as indexwK9JwlU41tMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/[bookId]/index.vue?macro=true";
import { default as indexg1rubMHdlTMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/index.vue?macro=true";
import { default as writeA6RzDBw5WWMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/write.vue?macro=true";
import { default as indexGeGkVAa2AdMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/[magazineId]/index.vue?macro=true";
import { default as indexjpuFNy7WuSMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/board/[boardId]/index.vue?macro=true";
import { default as writedxsEsUxxOkMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/board/write.vue?macro=true";
import { default as indexslC3vhVkwcMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/index.vue?macro=true";
import { default as writeeHVuPswDP4Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/write.vue?macro=true";
import { default as indexRoFJchSZExMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/main/index.vue?macro=true";
import { default as indexeyThgFw2QUMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/apply/membership/[membershipApplyId]/index.vue?macro=true";
import { default as indexDhuVpsPkIlMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/apply/seminar/[seminarApplyId]/index.vue?macro=true";
import { default as indexzfWSwVpbK2Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/index.vue?macro=true";
import { default as indexUyn2aEkAu8Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/payment/[paymentId]/index.vue?macro=true";
import { default as indexhHXYf9W5k0Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/[memberId]/edit/index.vue?macro=true";
import { default as index7WIRqlx5RlMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/[memberId]/index.vue?macro=true";
import { default as indexxPEScxsLEUMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/index.vue?macro=true";
import { default as indexgPJi2c59PIMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/board/[boardId]/index.vue?macro=true";
import { default as writegWS0UHXIHlMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/board/write.vue?macro=true";
import { default as indextBo4MH0ffcMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/index.vue?macro=true";
import { default as index01IvPs7KPgMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/partnership/index.vue?macro=true";
import { default as editsncSp3Nlm7Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/[seminarId]/edit.vue?macro=true";
import { default as indexFlJT6cxhHsMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/[seminarId]/index.vue?macro=true";
import { default as indexV5sMlJEImAMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/index.vue?macro=true";
import { default as indexxjkUL7HVJ2Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/mail-apply/[mailApplyId]/index.vue?macro=true";
import { default as writePvVknGWMo8Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/write.vue?macro=true";
import { default as indexqZcvS4mZRkMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/terms/index.vue?macro=true";
import { default as index740VqT8qHEMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/cart/index.vue?macro=true";
import { default as index4EjILbkqgwMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/ceo/index.vue?macro=true";
import { default as indexCIJV2wKwXKMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/customer-service/index.vue?macro=true";
import { default as index0pvoekjP0NMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/find/id/index.vue?macro=true";
import { default as indexlccrjWU6O4Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/find/password/index.vue?macro=true";
import { default as indexU6KPcTVp3aMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/greeting/index.vue?macro=true";
import { default as indexxroffAA9j9Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/[hrId]/index.vue?macro=true";
import { default as index3ImcjGgzV8Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/index.vue?macro=true";
import { default as paymentUGESEmzRp9Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/payment.vue?macro=true";
import { default as indexKUFEpP57uGMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/index.vue?macro=true";
import { default as index5gJHxo1WQZMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/information/index.vue?macro=true";
import { default as indexQpfowCEWloMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/insa/index.vue?macro=true";
import { default as indexfXD4oVMqeuMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/[bookId]/index.vue?macro=true";
import { default as indexXqB05lYeYoMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/index.vue?macro=true";
import { default as paymentInnjjEueGMMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/payment.vue?macro=true";
import { default as indexoeYK7bKHEjMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/login/index.vue?macro=true";
import { default as indexjmMpQzS0GOMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/[magazineId]/index.vue?macro=true";
import { default as indexOsOuunLfPzMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/board/[boardId]/index.vue?macro=true";
import { default as paymentyqj6rehYeqMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/board/payment.vue?macro=true";
import { default as indexmyE7YFJaFQMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/index.vue?macro=true";
import { default as paymentEI20ogj7wQMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/payment.vue?macro=true";
import { default as index1tfEz0GLjHMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/board/[boardId]/index.vue?macro=true";
import { default as indexIMs8Hu61sMMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/index.vue?macro=true";
import { default as paymentsEEtr1fd6WMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/payment.vue?macro=true";
import { default as indexlWYuC0koJyMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/mypage/[applicationId]/index.vue?macro=true";
import { default as indexDrahz2i98tMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/mypage/index.vue?macro=true";
import { default as indexEf2MlBetoHMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/partnership/index.vue?macro=true";
import { default as indexpo8XGh12uHMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/search/index.vue?macro=true";
import { default as index90xcryaHFsMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/[seminarId]/index.vue?macro=true";
import { default as indexBEJpQyAcmAMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/index.vue?macro=true";
import { default as paymentEfUjDs6J2aMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/payment.vue?macro=true";
import { default as indexNpbW9WtIE7Meta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/signup/index.vue?macro=true";
import { default as indexjPdZEX5qvsMeta } from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/terms/index.vue?macro=true";
export default [
  {
    name: "admin-ceo",
    path: "/admin/ceo",
    meta: indexys1qErV1bGMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/ceo/index.vue")
  },
  {
    name: "admin-customer-service",
    path: "/admin/customer-service",
    meta: indexFJxrNCJKjKMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/customer-service/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: indexHvwaloWIJjMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/dashboard/index.vue")
  },
  {
    name: "admin-greeting",
    path: "/admin/greeting",
    meta: indexuGjfd422WVMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/greeting/index.vue")
  },
  {
    name: "admin-hr-hrId",
    path: "/admin/hr/:hrId()",
    meta: index30iB83j3tHMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/[hrId]/index.vue")
  },
  {
    name: "admin-hr",
    path: "/admin/hr",
    meta: indexZ6OFxJ0LSCMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/index.vue")
  },
  {
    name: "admin-hr-write",
    path: "/admin/hr/write",
    meta: write0Zsamok7GoMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/hr/write.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexVGsj7JK8TRMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/index.vue")
  },
  {
    name: "admin-insa",
    path: "/admin/insa",
    meta: indexrtUWuunv1RMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/insa/index.vue")
  },
  {
    name: "admin-kpi-book-bookId",
    path: "/admin/kpi-book/:bookId()",
    meta: indexwK9JwlU41tMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/[bookId]/index.vue")
  },
  {
    name: "admin-kpi-book",
    path: "/admin/kpi-book",
    meta: indexg1rubMHdlTMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/index.vue")
  },
  {
    name: "admin-kpi-book-write",
    path: "/admin/kpi-book/write",
    meta: writeA6RzDBw5WWMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/kpi-book/write.vue")
  },
  {
    name: "admin-magazine-magazineId",
    path: "/admin/magazine/:magazineId()",
    meta: indexGeGkVAa2AdMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/[magazineId]/index.vue")
  },
  {
    name: "admin-magazine-board-boardId",
    path: "/admin/magazine/board/:boardId()",
    meta: indexjpuFNy7WuSMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/board/[boardId]/index.vue")
  },
  {
    name: "admin-magazine-board-write",
    path: "/admin/magazine/board/write",
    meta: writedxsEsUxxOkMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/board/write.vue")
  },
  {
    name: "admin-magazine",
    path: "/admin/magazine",
    meta: indexslC3vhVkwcMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/index.vue")
  },
  {
    name: "admin-magazine-write",
    path: "/admin/magazine/write",
    meta: writeeHVuPswDP4Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/magazine/write.vue")
  },
  {
    name: "admin-main",
    path: "/admin/main",
    meta: indexRoFJchSZExMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/main/index.vue")
  },
  {
    name: "admin-management-apply-membership-membershipApplyId",
    path: "/admin/management/apply/membership/:membershipApplyId()",
    meta: indexeyThgFw2QUMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/apply/membership/[membershipApplyId]/index.vue")
  },
  {
    name: "admin-management-apply-seminar-seminarApplyId",
    path: "/admin/management/apply/seminar/:seminarApplyId()",
    meta: indexDhuVpsPkIlMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/apply/seminar/[seminarApplyId]/index.vue")
  },
  {
    name: "admin-management",
    path: "/admin/management",
    meta: indexzfWSwVpbK2Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/index.vue")
  },
  {
    name: "admin-management-payment-paymentId",
    path: "/admin/management/payment/:paymentId()",
    meta: indexUyn2aEkAu8Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/management/payment/[paymentId]/index.vue")
  },
  {
    name: "admin-member-memberId-edit",
    path: "/admin/member/:memberId()/edit",
    meta: indexhHXYf9W5k0Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/[memberId]/edit/index.vue")
  },
  {
    name: "admin-member-memberId",
    path: "/admin/member/:memberId()",
    meta: index7WIRqlx5RlMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/[memberId]/index.vue")
  },
  {
    name: "admin-member",
    path: "/admin/member",
    meta: indexxPEScxsLEUMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/member/index.vue")
  },
  {
    name: "admin-membership-business-board-boardId",
    path: "/admin/membership-business/board/:boardId()",
    meta: indexgPJi2c59PIMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/board/[boardId]/index.vue")
  },
  {
    name: "admin-membership-business-board-write",
    path: "/admin/membership-business/board/write",
    meta: writegWS0UHXIHlMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/board/write.vue")
  },
  {
    name: "admin-membership-business",
    path: "/admin/membership-business",
    meta: indextBo4MH0ffcMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/membership-business/index.vue")
  },
  {
    name: "admin-partnership",
    path: "/admin/partnership",
    meta: index01IvPs7KPgMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/partnership/index.vue")
  },
  {
    name: "admin-seminar-seminarId-edit",
    path: "/admin/seminar/:seminarId()/edit",
    meta: editsncSp3Nlm7Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/[seminarId]/edit.vue")
  },
  {
    name: "admin-seminar-seminarId",
    path: "/admin/seminar/:seminarId()",
    meta: indexFlJT6cxhHsMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/[seminarId]/index.vue")
  },
  {
    name: "admin-seminar",
    path: "/admin/seminar",
    meta: indexV5sMlJEImAMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/index.vue")
  },
  {
    name: "admin-seminar-mail-apply-mailApplyId",
    path: "/admin/seminar/mail-apply/:mailApplyId()",
    meta: indexxjkUL7HVJ2Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/mail-apply/[mailApplyId]/index.vue")
  },
  {
    name: "admin-seminar-write",
    path: "/admin/seminar/write",
    meta: writePvVknGWMo8Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/seminar/write.vue")
  },
  {
    name: "admin-terms",
    path: "/admin/terms",
    meta: indexqZcvS4mZRkMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/admin/terms/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/cart/index.vue")
  },
  {
    name: "ceo",
    path: "/ceo",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/ceo/index.vue")
  },
  {
    name: "customer-service",
    path: "/customer-service",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/customer-service/index.vue")
  },
  {
    name: "find-id",
    path: "/find/id",
    meta: index0pvoekjP0NMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/find/id/index.vue")
  },
  {
    name: "find-password",
    path: "/find/password",
    meta: indexlccrjWU6O4Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/find/password/index.vue")
  },
  {
    name: "greeting",
    path: "/greeting",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/greeting/index.vue")
  },
  {
    name: "hr-hrId",
    path: "/hr/:hrId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/[hrId]/index.vue")
  },
  {
    name: "hr",
    path: "/hr",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/index.vue")
  },
  {
    name: "hr-payment",
    path: "/hr/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/hr/payment.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/information/index.vue")
  },
  {
    name: "insa",
    path: "/insa",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/insa/index.vue")
  },
  {
    name: "kpi-book-bookId",
    path: "/kpi-book/:bookId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/[bookId]/index.vue")
  },
  {
    name: "kpi-book",
    path: "/kpi-book",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/index.vue")
  },
  {
    name: "kpi-book-payment",
    path: "/kpi-book/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/kpi-book/payment.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexoeYK7bKHEjMeta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/login/index.vue")
  },
  {
    name: "magazine-magazineId",
    path: "/magazine/:magazineId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/[magazineId]/index.vue")
  },
  {
    name: "magazine-board-boardId",
    path: "/magazine/board/:boardId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/board/[boardId]/index.vue")
  },
  {
    name: "magazine-board-payment",
    path: "/magazine/board/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/board/payment.vue")
  },
  {
    name: "magazine",
    path: "/magazine",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/index.vue")
  },
  {
    name: "magazine-payment",
    path: "/magazine/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/magazine/payment.vue")
  },
  {
    name: "membership-business-board-boardId",
    path: "/membership-business/board/:boardId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/board/[boardId]/index.vue")
  },
  {
    name: "membership-business",
    path: "/membership-business",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/index.vue")
  },
  {
    name: "membership-business-payment",
    path: "/membership-business/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/membership-business/payment.vue")
  },
  {
    name: "mypage-applicationId",
    path: "/mypage/:applicationId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/mypage/[applicationId]/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/mypage/index.vue")
  },
  {
    name: "partnership",
    path: "/partnership",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/partnership/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/search/index.vue")
  },
  {
    name: "seminar-seminarId",
    path: "/seminar/:seminarId()",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/[seminarId]/index.vue")
  },
  {
    name: "seminar",
    path: "/seminar",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/index.vue")
  },
  {
    name: "seminar-payment",
    path: "/seminar/payment",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/seminar/payment.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexNpbW9WtIE7Meta || {},
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/signup/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/Users/bridgecode/workspace/insabank/insabank_frontend/src/pages/terms/index.vue")
  }
]